module.exports = __webpack_public_path__ + "static/media/30.8e1f13a1.png";